const PURCHASED_CUSTOM_PRINT_STATUS = {
  CUSTOMER_INPUT: 'CUSTOMER_INPUT',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  CANCELED: 'CANCELED',
};

const PCM_ORDER_STATUS = {
  MAILING: 'MAILING',
  DELIVERED: 'DELIVERED',
};

const SPECIALTY_PRINTS_PHOTOS_NO = [1, 2, 3, 4, 5];

export {
  PURCHASED_CUSTOM_PRINT_STATUS,
  PCM_ORDER_STATUS,
  SPECIALTY_PRINTS_PHOTOS_NO,
};
